// Alert levels — used for river gauge icons, river polygon fills, flood extents, and well icons
export const ALERT_COLORS: Record<string, string> = {
  normal: "#3fb950",
  watch:  "#fbbf24",
  high:   "#ff4444",
};

// Rainfall intensity icon colours (icon fill and trend-arrow tint)
export const RAIN_COLOR_DRY      = "#f0f1f2"; // dry     (< 1 mm/hr)
export const RAIN_COLOR_LIGHT    = "#ffe600"; // light   (1–10 mm/hr)
export const RAIN_COLOR_MODERATE = "#ff8800"; // moderate(10–25 mm/hr)
export const RAIN_COLOR_HEAVY    = "#ff2244"; // heavy   (≥ 25 mm/hr)

// Rainfall intensity thresholds (mm/hr, 1-hour accumulated total)
export const RAIN_LIGHT    = 1;
export const RAIN_MODERATE = 10;
export const RAIN_HEAVY    = 25;

// Well groundwater-level icon + halo colour pairs
export const WELL_COLORS = {
  high:    { icon: "#3b82f6", halo: "#3b82f6" },
  normal:  { icon: "#0d652d", halo: "#22c55e" },
  low:     { icon: "#b07207", halo: "#f59e0b" },
  lowData: { icon: "#9ca3af", halo: "#9ca3af" },
  stale:   { icon: "#6b21a8", halo: "#6b21a8" },
};

// River polygon colours for unmonitored reaches (no matched gauge)
export const RIVER_UNMONITORED_LINE = "#5b9bc4"; // border + fill-outline
export const RIVER_UNMONITORED_FILL = "#00b4ff"; // fill interior

// Flood extent polygon colours, keyed by Status field ("Current" / "Historic")
export const FLOOD_CURRENT_FILL  = "#2563eb";
export const FLOOD_CURRENT_LINE  = "#1d4ed8";
export const FLOOD_HISTORIC_FILL = "#93c5fd";
export const FLOOD_HISTORIC_LINE = "#60a5fa";
